import { useEffect, useState } from "react";

import { Button, Input, Modal } from "antd";
import styled from "styled-components";
import { useAxios } from "../hooks";

const StyledModal = styled(Modal)`
  .ant-modal-body {
    max-height: 60vh;
    overflow-y: auto;
  }

  .ant-modal-footer {
    .ant-btn {
      width: 30%;
    }
  }
`;

const Wrapper = styled.div`
  margin-bottom: 10px;

  label {
    margin-bottom: 6px;
  }
`;

const AttributesDefinitionModal = ({
  onboarding,
  attributes,
  open,
  onClose,
  selectedAttributes = [],
}) => {
  const { fetch: onFetch, loading } = useAxios();
  const { fetch: onSave, loading: submitLoading } = useAxios();
  const [attributesDefinition, setAttributesDefinition] = useState({});

  useEffect(() => {
    if (open) {
      fetchDetails();
    }
  }, [open]);

  const fetchDetails = async () => {
    try {
      const { data } = await onFetch({
        url: `/company/${onboarding.id}/attributes-config/`,
        method: "GET",
      });
      for (const attr of selectedAttributes) {
        const element = data.find((ele) => ele?.attribute?.id === attr);
        if (element) {
          attributesDefinition[attr] = element.description;
        }
      }
      setAttributesDefinition(attributesDefinition);
    } catch (error) {
      console.error("Error fetching attributes definition:", error);
    }
  };

  const onBeforeClose = () => {
    onClose();
    setAttributesDefinition({});
  };

  const onSubmit = async () => {
    try {
      const payload = selectedAttributes.map((attr) => ({
        attribute: attr,
        description: attributesDefinition[attr] || "",
      }));
      // console.log("Submitting attributes definition payload:", payload);
      await onSave({
        url: `/company/${onboarding.id}/attributes-config/`,
        method: "POST",
        data: payload,
      });
      onBeforeClose();
    } catch (error) {
      console.error("Error saving attributes definition:", error);
    }
  };

  return (
    <StyledModal
      open={open}
      onCancel={onBeforeClose}
      centered
      destroyOnHidden
      loading={loading}
      title="Attributes Definition"
      footer={[
        <Button
          disabled={submitLoading}
          key="close"
          type="primary"
          ghost
          onClick={onBeforeClose}
        >
          Close
        </Button>,
        <Button
          loading={submitLoading}
          key="save"
          type="primary"
          onClick={onSubmit}
        >
          Save
        </Button>,
      ]}
    >
      {selectedAttributes.map((ele, index) => {
        const element = attributes.find((attr) => attr.id === ele);
        const key = element?.id || ele;
        return (
          <Wrapper id={element?.id || index}>
            <label>{element?.name || ele}</label>
            <Input.TextArea
              rows={4}
              value={attributesDefinition[key] || ""}
              onChange={(e) =>
                setAttributesDefinition((prev) => ({
                  ...prev,
                  [key]: e.target.value,
                }))
              }
            />
          </Wrapper>
        );
      })}
    </StyledModal>
  );
};

export default AttributesDefinitionModal;
